var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('xh-header'),(_vm.banner.length)?_c('ny-banner',{attrs:{"banner":_vm.banner[0]}}):_vm._e(),_c('single-page'),_c('xh-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }